import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  GetSingleSurveyUser,
  reset,
} from "../../../features/survey_user/SurveyUserSlice";

import {
  Card,
  Form,
  Col,
  Row,
  Table,
  Badge,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import moment from "moment";

const DetailSurveyUserPage = () => {
  const [newData, setNewData] = useState({
    nama: "",
    deskripsi: "",
    active: true,
    detail: [],
  });

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.surveyUser);

  const { id, idUser } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());

    // fetch data.
    if (id) {
      fetchData();
    }
  }, [id, dispatch, token]);

  function fetchData() {
    dispatch(reset());
    dispatch(GetSingleSurveyUser({ id, idUser, token }));
  }

  useEffect(() => {
    setNewData({
      nama: data?.data?.nama,
      deskripsi: data?.data?.deskripsi,
      nim: data?.data?.nim,
      nama_user: data?.data?.nama_user,
      input_date: data?.data?.input_date,
      total_point: data?.data?.total_point,
      detail: data?.data?.detail,
      active: data?.data?.active,
    });
  }, [data]);

  return (
    <AdminLayout>
      <Header />
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          newData={newData}
          isLoading={isLoading}
          isLocked={true}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({ id, newData, isLocked = false, isLoading = false }) => {
  // TODO : MAKE THIS ONE CODE BASE SO IT CAN UPDATED EASILY
  const pointDeskriptor = (point) => {
    let variant = 0;
    let text = "";
    if (point === 1) {
      variant = "danger";
      text = "TIDAK PUAS";
    } else if (point === 2) {
      variant = "warning";
      text = "BIASA";
    } else if (point === 3) {
      variant = "info";
      text = "PUAS";
    } else if (point === 4) {
      variant = "success";
      text = "SANGAT PUAS";
    }
    return <Badge bg={variant}>{text}</Badge>;
  };

  const hitungNilaiKeseluruhan = () => {
    if ((newData?.detail || []).length > 0) {
      // 4 is the max point that the detail can get
      const xP = newData?.detail?.length * 4;
      const point = newData?.detail?.map(e => e.point).reduce((a, b) => (a || 0)+(b || 0));
      const total = Math.round((point/xP)*100);

      if (total < 26) return "TIDAK PUAS";
      else if (total < 51) return "BIASA";
      else if (total < 76) return "PUAS";
      else if (total >= 76) return "SANGAT PUAS";
    }
    return "-";
  }

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Form>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="Nama">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={isLocked}
                  value={newData.nama || ""}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="deskripsi">
                <Form.Label>Deskripsi</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="deskripsi"
                  name="deskripsi"
                  disabled={isLocked}
                  value={newData.deskripsi || ""}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="nim">
                <Form.Label>NIM</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="nim"
                  name="nim"
                  disabled={isLocked}
                  value={newData.nim || ""}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="nama_user">
                <Form.Label>Nama User</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="nama_user"
                  name="nama_user"
                  disabled={isLocked}
                  value={newData.nama_user || ""}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="input_date">
                <Form.Label>Tanggal Dibuat</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="input_date"
                  name="input_date"
                  disabled={isLocked}
                  value={
                    moment(newData.input_date).format("DD MMM YYYY HH:mm:ss") || ""
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="overal_rate">
                <Form.Label>Nilai Keseluruhan</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="overal_rate"
                  name="overal_rate"
                  disabled={isLocked}
                  value={
                    hitungNilaiKeseluruhan() || ""
                  }
                />
              </Form.Group>
            </Col>
            <hr data-content="Detail" className="hr-text" />
            <Col md={12} className="mb-3">
              <Table
                responsive
                striped
                className="table-centered table-nowrap rounded mb-0"
              >
                <thead className="thead-light">
                  <tr>
                    <th className="border-0">#</th>
                    <th className="border-0">Deskripsi</th>
                    <th className="border-0">Penilaian</th>
                  </tr>
                </thead>
                <tbody>
                  {(newData.detail || []).length > 0 ? (
                    newData.detail?.map((item, i) => (
                      <tr key={i}>
                        <th>{i + 1}</th>
                        <th>{item.deskripsi}</th>
                        <th style={{ textAlign: "center" }}>
                          {pointDeskriptor(item.point)}
                        </th>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th colSpan="3" style={{ textAlign: "center" }}>
                        Tidak ada data!
                      </th>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Form>
      )}
    </Card.Body>
  );
};

export default DetailSurveyUserPage;
